export const GET_ANNOUNCEMENT = "GET_ANNOUNCEMENT";
export const ADD_ANNOUNCEMENT = "ADD_ANNOUNCEMENT";
export const DELETE_ANNOUNCEMENT = "DELETE_ANNOUNCEMENT";
export const GET_EXPIRED_ANNOUNCEMENTS = "GET_EXPIRED_ANNOUNCEMENTS";
export const SHOW_ANNOUNCEMENT = "SHOW_ANNOUNCEMENT";
export const SET_ANNOUNCEMENT_LOADER = "SET_ANNOUNCEMENT_LOADER";
